import { render } from "./RequestResetPass.vue?vue&type=template&id=3ab69cfa"
import script from "./RequestResetPass.vue?vue&type=script&lang=js"
export * from "./RequestResetPass.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn});
